export default function RoleViewEditController(
  $scope,
  $state,
  $stateParams,
  $filter,
  usersService,
  RoleService,
  FeatureService,
  gettextCatalog,
) {
  'ngInject';

  $scope.dataPointsByPage = [];
  $scope.filteredDataPoints = [];
  $scope.datapointsDenied = [];
  $scope.editingPermission = false;
  $scope.editingRoleData = {};
  $scope.useSecurityGroupsChanged = false;
  $scope.existingNames = [];
  $scope.search = {
    query: '',
    text: '',
  };
  $scope.successFlag = false;
  $scope.changeApplied = false;
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.loading = true;
  $scope.sending = false;
  $scope.setAll = {};
  $scope.datapointsSelectedCount = 0;

  $scope.features = [];
  $scope.sortedPermissions = [];

  $scope.getAllPermissions = function () {
    FeatureService.getFeatures().then(
      function (response) {
        const currentUserFeatures = usersService.currentUser().permissions;
        //set disabled based on user permission
        const features = response.data.map((f) => ({
          ...f,
          disabled: !currentUserFeatures.includes(f.path),
        }));
        $scope.hasDisabledFeatures = features.filter((f) => f.disabled).length > 0;

        $scope.features = features;
        $scope.sortedPermissions = features;
        $scope.checkExistingPermissions($scope.editingRoleData.featureList);
      },
      function (error) {
        let errorMsg = gettextCatalog.getString('An error occurred getting role data');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.sending = false;
      },
    );
  };

  $scope.getLeftPermissionPadding = function (permission) {
    if (!permission.path) return 0;

    return $scope.countPeriods(permission.path) * 50;
  };

  $scope.countPeriods = function (input) {
    let result = 0;

    for (let i = 0; i < input.length; i++) {
      if (input[i] == '.') {
        result++;
      }
    }
    return result;
  }; //countPeriods

  $scope.selectAllPermissions = function (flag) {
    for (let i = 0; i < $scope.sortedPermissions.length; i++) {
      $scope.sortedPermissions[i].checked = flag;
    }
    window.dataLayer.push({
      event: flag ? 'rolePermissionAllSelected' : 'rolePermissionAllDeselected',
    });
  };

  $scope.checkParent = function (path, flag) {
    let name = path.substr(0, path.indexOf('.'));

    if (flag && name.length > 0) {
      let childPath = '';

      if ($scope.countPeriods(path) > 1) {
        childPath = path.substr(0, path.lastIndexOf('.'));
      }

      for (var i = 0; i < $scope.sortedPermissions.length; i++) {
        if (
          $scope.sortedPermissions[i].path === name ||
          $scope.sortedPermissions[i].path == childPath
        ) {
          $scope.sortedPermissions[i].checked = flag;
        }
      }
    }
    //if parent is unchecked, uncheck all the children of the parent
    else if (name.length === 0 && !flag) {
      for (var i = 0; i < $scope.sortedPermissions.length; i++) {
        let childName = $scope.sortedPermissions[i].path.substr(
          0,
          $scope.sortedPermissions[i].path.indexOf('.'),
        );
        if (path === childName) {
          $scope.sortedPermissions[i].checked = flag;
        }
      }
    } else if (!flag) {
      //check to see if path has children
      for (var i = 0; i < $scope.sortedPermissions.length; i++) {
        if ($scope.sortedPermissions[i].path.indexOf(path) > -1) {
          $scope.sortedPermissions[i].checked = flag;
        }
      }
    }

    window.dataLayer.push({
      event: 'rolePermissionChanged',
      data: {
        permission: path,
        checked: flag,
      },
    });
  }; //checkParent

  //Sorting
  $scope.predicate1 = 'description';
  $scope.reverse1 = true;
  let orderBy = $filter('orderBy');

  //Sort filteredDataPoints
  $scope.orderDataPoints = function (predicate1, loaded = false) {
    $scope.predicate1 = predicate1;
    $scope.reverse1 = $scope.predicate1 === predicate1 ? !$scope.reverse1 : false;

    angular.forEach($scope.filteredDataPoints, function (datapoint) {
      datapoint[predicate1] = datapoint[predicate1];
    });
    $scope.filteredDataPoints = orderBy($scope.filteredDataPoints, predicate1, $scope.reverse1);
    $scope.displayDataPointsByPage();
    if (!loaded) GTM_DatapointChanges('roleDatapointsOrderChanged');
  };

  //Pagination
  $scope.current = {
    page: 1,
    policyPage: 1,
  };
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;

  //displayDataPointsByPage() is used to set the legnth of paging needed for filteredDataPoints.
  $scope.displayDataPointsByPage = function () {
    $scope.totalItems = $scope.filteredDataPoints.length;
    let begin = ($scope.current.page - 1) * $scope.itemsPerPage;
    let end = begin + $scope.itemsPerPage;
    $scope.dataPointsByPage = $scope.filteredDataPoints.slice(begin, end);
  };

  //Calls displayDataPointsByPage(), everytime the the user changes the page.
  $scope.pageChanged = function () {
    $scope.displayDataPointsByPage();
    GTM_DatapointChanges('roleDatapointsPageChanged');
  };

  //applyFilter() searches the dataPoints[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredDataPoints = $filter('filter')($scope.datapoints, $scope.search.query);
    $scope.displayDataPointsByPage();
    GTM_DatapointChanges('roleDatapointsFiltered');
  };

  $scope.applyChange = function () {
    $scope.resetFlags();
    $scope.changeApplied = true;
  };

  $scope.saveButtonPressed = function () {
    if ($scope.roleForm.$invalid || $scope.sending || $scope.roleForm.$error.maxlength) {
      return;
    }
    $scope.sending = true;
    $scope.successFlag = false;
    $scope.errorFlag = false;
    $scope.editingRoleData.featureList = [];

    //loop through the sort permissions to find the checked permissions and push them into the PUT object
    for (let i = 0; i < $scope.sortedPermissions.length; i++) {
      for (let x = 0; x < $scope.features.length; x++) {
        if (
          $scope.sortedPermissions[i].path === $scope.features[x].path &&
          $scope.sortedPermissions[i].checked
        ) {
          $scope.editingRoleData.featureList.push($scope.features[x]);
        }
      } //inner for
    } //out for

    RoleService.updateRole($scope.editingRoleData).then(
      function (response) {
        $scope.changeApplied = false;
        $scope.successFlag = true;
        $scope.sending = false;
        $state.go('admin.userroledetails', {
          roleId: response.data.id,
        });
      },
      function (error) {
        let errorMsg = gettextCatalog.getString(
          'An error occurred while updating role information',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.sending = false;
      },
    );
  };

  let getExistingNames = function () {
    RoleService.getRoles().then(
      function onSuccess(response) {
        $scope.existingNames = [];
        for (let i = 0; i < response.data.length; i++) {
          $scope.existingNames.push(response.data[i].name);
        }
        if ($scope.datapoints && $scope.rolePolicies) {
          $scope.loading = false;
          $scope.$emit('$viewContentLoaded'); //breadcrumbs fix
        }
      },
      function onError(error) {
        let errorMsg = gettextCatalog.getString('An error occurred');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        if ($scope.loading) {
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
          $scope.loading = false;
          $scope.$emit('$viewContentLoaded'); //breadcrumbs fix
        }
      },
    );
  };

  let getRoleData = function () {
    RoleService.getRole($stateParams.roleId).then(
      function (response) {
        $scope.roleData = response.data;
        if (!$state.current.ncyBreadcrumbLabel) {
          $state.current.ncyBreadcrumbLabel = $scope.roleData.name;
        }
        if (!$scope.roleData.dataPointsDenied) {
          $scope.roleData.dataPointsDenied = [];
        }
        $scope.editingRoleData = angular.copy($scope.roleData);
        getExistingNames();
        getRoleDatapoints();
        $scope.getAllPermissions();
      },
      function (error) {
        if (!$state.current.ncyBreadcrumbLabel) {
          if ($scope.$parent.selectedName) {
            $state.current.ncyBreadcrumbLabel = $scope.$parent.selectedName;
          } else {
            $state.current.ncyBreadcrumbLabel = 'Error';
          }
        }
        let errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving role information',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        if ($scope.loading) {
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
          $scope.loading = false;
        }
      },
    );
  };

  let getRoleDatapoints = function () {
    usersService.getDatapoints().then(
      function (response) {
        $scope.datapoints = response.data;

        angular.forEach($scope.datapoints, function (obj) {
          obj['checkedDatapoint'] = true;
        });

        if ($scope.roleData.dataPointsDenied) {
          for (let i = 0; i < $scope.datapoints.length; i++) {
            for (let j = 0; j < $scope.roleData.dataPointsDenied.length; j++) {
              if ($scope.datapoints[i].id === $scope.roleData.dataPointsDenied[j]) {
                $scope.datapoints[i].checkedDatapoint = false;
                break;
              }
            }
          }
          $scope.editingRoleData.dataPointsDenied = angular.copy($scope.roleData.dataPointsDenied);
        }

        $scope.datapointsSelectedCount =
          $scope.datapoints.length - $scope.editingRoleData.dataPointsDenied.length;

        $scope.originalDatapoints = angular.copy($scope.datapoints);
        $scope.filteredDataPoints = $scope.datapoints;
        $scope.orderDataPoints('description', true);
        $scope.displayDataPointsByPage();
        if ($scope.rolePolicies && $scope.existingNames) {
          $scope.loading = false;
          $scope.$emit('$viewContentLoaded'); //breadcrumbs fix
        }
        if ($scope.loading) {
          $scope.loading = false;
        }
        GTM_DatapointChanges('roleDatapointsLoaded');
      },
      function (error) {
        if (!$state.current.ncyBreadcrumbLabel) {
          if ($scope.$parent.selectedName) {
            $state.current.ncyBreadcrumbLabel = $scope.$parent.selectedName;
          } else {
            $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Error');
          }
        }
        let errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving role information',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        if ($scope.loading) {
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
          $scope.loading = false;
          $scope.$emit('$viewContentLoaded'); //breadcrumbs fix
        }
      },
    );
  };

  $scope.datapointSelected = function (id) {
    $scope.resetFlags();
    for (let i = 0; i < $scope.editingRoleData.dataPointsDenied.length; i++) {
      if ($scope.editingRoleData.dataPointsDenied[i] === id) {
        $scope.editingRoleData.dataPointsDenied.splice(i, 1);
        $scope.datapointsSelectedCount++;
        $scope.applyChange();
        GTM_DatapointChanges('roleDatapointSelected');
        return;
      }
    }
    $scope.editingRoleData.dataPointsDenied.push(id);
    $scope.datapointsSelectedCount--;
    $scope.applyChange();
    GTM_DatapointChanges('roleDatapointDeselected');
  };

  $scope.resetFlags = function () {
    $scope.successFlag = false;
    $scope.errorFlag = false;
  };

  getRoleData();

  $scope.nameExists = function () {
    if (!$scope.editingRoleData.name) {
      return false;
    }
    if ($scope.editingRoleData.name.toLowerCase() === $scope.roleData.name.toLowerCase()) {
      return false;
    }
    for (let i = 0; i < $scope.existingNames.length; i++) {
      if ($scope.editingRoleData.name.toLowerCase() === $scope.existingNames[i].toLowerCase()) {
        return true;
      }
    }
    return false;
  };

  $scope.checkAllDatapoints = function () {
    $scope.resetFlags();
    $scope.editingRoleData.dataPointsDenied = [];

    for (let i = 0; i < $scope.datapoints.length; i++) {
      $scope.datapoints[i].checkedDatapoint = $scope.setAll.datapoints;

      if (!$scope.setAll.datapoints) {
        $scope.editingRoleData.dataPointsDenied.push($scope.datapoints[i].id);
      }
      $scope.applyChange();
    }

    if ($scope.setAll.datapoints) {
      $scope.datapointsSelectedCount = $scope.datapoints.length;
    } else $scope.datapointsSelectedCount = 0;

    GTM_DatapointChanges(
      $scope.setAll.datapoints ? 'roleDatapointsAllSelected' : 'roleDatapointsAllDeselected',
    );
  };

  $scope.editDisabled = function () {
    if (!$scope.editingRoleData.name) return true;
    return $scope.editingRoleData.name.length == 0 || $scope.nameExists() || $scope.sending;
  };

  $scope.checkExistingPermissions = function (featureList) {
    for (let i = 0; i < $scope.sortedPermissions.length; i++) {
      for (let x = 0; x < featureList.length; x++) {
        if ($scope.sortedPermissions[i].path === featureList[x].path) {
          $scope.sortedPermissions[i].checked = true;
        }
      }
    }
  };

  $scope.nameChanged = function () {
    $scope.resetFlags();
    window.dataLayer.push({
      event: 'roleNameChanged',
    });
  };

  $scope.assetVisiblityChanged = function () {
    $scope.useSecurityGroupsChanged = true;
    window.dataLayer.push({
      event: 'roleVisiblityChanged',
      data: {
        assetsVisible: $scope.editingRoleData.useSecurityGroups,
      },
    });
  };

  $scope.descriptionChanged = function () {
    window.dataLayer.push({
      event: 'roleDescriptionChanged',
    });
  };

  function GTM_DatapointChanges(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.datapoints.length,
        totalFiltered: $scope.filteredDataPoints.length,
        totalSelected: $scope.datapointsSelectedCount,
        sortDirection: $scope.reverse1 ? 'descending' : 'ascending',
        pageNumber: $scope.current.page,
      },
    });
  }
}
